/* @flow */
/*jshint esversion: 6 */

import React, { Component } from "react";
import "../../App.css";
import { Table, Icon, Tooltip, Popover, Button, Row, Col, Form, InputNumber, message, Modal } from "antd";

import TableIDs from "../../data/TableIDs";
//import PageToolbar from "../../components/PageToolbar";
import ModalAccumulationOfPoints from "../../components/ModalAccumulationOfPoints";
import ModalCreateEditPointsCustomer from "../../components/ModalCreateEditPointsCustomer";
import ResponsiveTable from "../../components/ResponsiveTable";
import GenericModal from "../../components/GenericModal";
import FormItemInput from "../../components/FormItemInput";
import ReportTypeButton from "../../components/ReportTypeButton";
import ReportFavoriteSave from "../../components/ReportFavoriteSave";
import LangContext from "../../contextProvider/LangContext";
import GenericSelectorCustomers from "../../components/GenericSelectorCustomers";
import GenericSelector from "../../components/GenericSelector";
import GenericTable from "../../components/GenericTable";
import { Job, OutputType, ProcessType, User } from "../../JmReact";
import CustPicker from "../../components/CustPicker";
import GenericSelectorCustTags from "../../components/GenericSelectorCustTags";


const topHeight = 340; // px
const rowHeight = 30;  // px

type Props = {
    user: any,
    ui: any,
    uiActions: any,
    dataActions: any,
    data: Object
};
type State = {
    defaultItemCode: string,
    itemCodeSelectionVisible: boolean
};

class CustomerPoints extends Component<Props, State> {
    id: any;
    api: any;
    actionButtons: any;

    constructor(props: Props) {
        super(props);
        this.id = "CUSTOMER_POINTS_LIST";
        this.connected_id = "CONNECTED_CUSTOMER_POINTS_LIST";
        this.state = {
            height: window.innerHeight,
            defaultItemCode: "",
            itemCodeSelectionVisible: false,
            modalReportBranches: false,
            BranchesPoints: {
                dateFrom: null,
                dateTo: null,
                isPerBranch: 0,
                branchList: '',
                reportName: 'reports/BranchesPoints.pdf',
            },

            modalMultiAddToConnectedCust: false,
            modalMultiAddToConnectedCustList: false,
            addToConnectedCustFilter: {
                _custId: null,
                _custName: null,
                _maxPointsToAdd: null,
                _sumPointsToAdd: null,
                _ref: null,
                _posNumber: null,
            }
        };

        // calc page height
        this.doOnResize = null;

        if (props.data[this.id] === undefined) {
            props.data[this.id] = { ...props.data.genericData };
        }

        if (props.data[this.connected_id] === undefined) {
            props.data[this.connected_id] = { ...props.data.genericData };
        }

        if (props.data[this.DATA_SET_NAME] === undefined) {
            props.data[this.DATA_SET_NAME] = Object.assign({}, props.data.genericData);
        }

        if (props.data["posList"] === undefined) {
            props.data["posList"] = Object.assign({}, props.data.genericData);
        }

        if (props.data["mutList"] === undefined) {
            props.data["mutList"] = Object.assign({}, props.data.genericData);
        }
        if (props.data["customerList"] === undefined) {
            props.data["customerList"] = Object.assign({}, props.data.genericData);
        }

        if (props.data[TableIDs.genericSelectorBranches] === undefined) props.data[TableIDs.genericSelectorBranches] = { dataset: [] }

        this.api = {
            get: "get_dealsActuals_list",
            get_connected: "get_dealsActuals_list_to_connected_cust",
        }

        this.actionButtons = [
            {
                buttonType: 'filter',
                buttonFunction: () => { this.setState({ modalFilter: true }) }
            },
            {
                buttonType: 'add',
                buttonFunction: () => {
                    this.props.uiActions.showModal(TableIDs.modalCreateEditPointsCustomer, { ...this.props.ui.data, customerId: 0 });
                    this.props.dataActions.genericDataSetEdit("customer.editedRecord.customers", { customerId: '0' });
                }
            },
            {
                buttonType: 'refresh',
                buttonFunction: this.refreshData
            },
        ];


        this.props.ActionQueue.addToQueue({
            action: this.props.dataActions.genericDataGetWithParams, args: ["customerList", this.props.user.companyCode, this.props.user.token, {
                dataObject: "customerList"
            }, "data_get"]
        });

        this.selectors = [
            { id: "POS_LIST_BO_USER", api: "get_pos_list_bo_user" },
        ]

        this.selectors.forEach(x => { if (props.data[x.id] === undefined) { props.data[x.id] = { ...props.data.genericSelector } } })


    }


    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidMount() {
        this.props.dataActions.getItemCodes(this.props.user.companyCode, this.props.user.token);
        this.initFilters();
        window.addEventListener("resize", () => {
            clearTimeout(this.doOnResize);
            this.doOnResize = setTimeout(this.handleWindowSizeChange, 100)
        });
    }

    componentDidUpdate(prevProps) {
        document.title = "Cash On Tab - " + this.getText(10157);

        if (prevProps.ui.favoriteParams !== this.props.ui.favoriteParams) {
            let p = this.props.ui.favoriteParams;
            if (p && p.reportName && p.reportName.indexOf("BranchesPoints") > -1) {
                this.setState({
                    modalReportBranches: true,
                    BranchesPoints: p,
                })
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleWindowSizeChange);
    }

    handleWindowSizeChange = () => {
        if (!(/Android/i.test(navigator.userAgent)))
            // if (!this.props.ui.modalStack.includes(TableIDs.modalCreateEditPointsCustomer)) {
            this.setState({ height: window.innerHeight }, this.refreshData);
        // }
    };

    initFilters = () => {
        let numOfRowsByHeight = parseInt((this.state.height - topHeight > rowHeight)
            ? (this.state.height - topHeight) / rowHeight
            : 1);

        let request = {
            _id: 0, // connected customer primary id
            // ui
            _fieldId: false,
            page: 1,
            recordsPerPage: numOfRowsByHeight, //5,
            sortType: 1,
            sortColumn: 1,
            // api
            _words: '',
            _page_num: 1,
            _rows_num: numOfRowsByHeight, //5,
            _isAsc: 1,
            _sort_by: 'col_1',

            _custId: null,
            _primaryCustId: null,
            _custTagList: "",

        };
        this.props.dataActions.genericDataSetFilter(
            this.id, this.props.user.companyCode, this.props.user.token, request, this.api.get);
    }

    refreshData = () => {
        this.props.dataActions.genericDataGetRequested(
            this.id, this.props.user.companyCode, this.props.user.token, this.api.get);
    }


    handleTableChange = (pagination: Object, filters: Object, sorter: Object) => {
        let col = 6;
        // fall through
        switch (sorter.field) {
            case "key": col--; // fallsthrough  // 0
            case "dId": col--; // fallsthrough 
            case "dCustomerId": col--; // fallsthrough 
            case "dCustomerName": col--; // fallsthrough 
            case "dCustomerPhone": col--; // fallsthrough 
            case "dName": col--; // fallsthrough 
            case "dSumPoint": break; // 6
            default:
                col = 0;
        }

        let request = {
            _id: 0,
            // _fieldId: false,

            // just of ui-pagination update
            page: pagination.current,
            recordsPerPage: pagination.pageSize,
            sortType: sorter.order === undefined || sorter.order === "ascend" ? 1 : 0,
            sortColumn: col,

            _page_num: pagination.current,
            _rows_num: pagination.pageSize,
            _isAsc: sorter.order === undefined || sorter.order === "ascend" ? 1 : 0,
            _sort_by: 'col_' + col,

        };

        this.props.dataActions.genericDataSetFilter(
            this.id, this.props.user.companyCode, this.props.user.token, request, this.api.get)
    }

    reportButton = () => {
        let generateReport = (f, reportName) => {
            let params = {
                _id: 0,
                _words: encodeURIComponent(f._words),
                _page_num: 1,
                _rows_num: 999999,
                _isAsc: 1,

                _custId: this.state.modalFilterCustId ?? null,
                _primaryCustId: this.state.modalFilterPrimaryCust ?? null,
                _custTagList: this.state.modalFilterCustTags ?? "",

                reportName: "reports/" + reportName,
                REPORT_LOCALE: this.getText(101),
            }
            this.props.ActionQueue.addToQueue({
                action: this.props.dataActions.generateReport,
                args: [this.props.user.companyCode, this.props.user.token, params]
            });
        }

        let subButton = (text, type, reportName) => {
            let onClick = () => { generateReport(this.props.data[this.id].filters, reportName) }
            return (
                <Tooltip title={this.getText(text)}>
                    <Icon style={{ fontSize: 32 }} className={"clickable margin-4"} type={type} onClick={onClick} />
                </Tooltip>)
        }

        let content = (<div>
            {subButton(12721, "file-pdf", "CustomerPoints.pdf")}
            {subButton(12722, "file-excel", "CustomerPointsExcel.xls")}
        </div>);

        return (
            <Tooltip title={this.getText(12720)}>
                <Popover content={content} title={this.getText(12723)} trigger="click">
                    <Button key={"report-print"} className={"btn"} style={{ marginTop: "5px", marginLeft: "5px" }}>
                        <Icon style={{ fontSize: 16 }} type={"printer"} theme="outlined" />
                    </Button>
                </Popover>
            </Tooltip >)
    }

    getModalField = (label, type, field) => {
        return (<FormItemInput
            label={this.getText(label)}
            inputType={type}
            value={this.state.BranchesPoints[field]}
            onChange={e => {
                this.setState({
                    BranchesPoints: {
                        ...this.state.BranchesPoints,
                        [field]: e
                    }
                })
            }} />)
    }

    onSaveAddToConnectedCust = () => {
        let dataSend = "mCustomerId\fmActionType\fmInputType\fmInput\fmPosNumber\fmRef"
        let custCount = 0;
        this.props.data[this.connected_id].data.forEach(x => {
            let y = x.split("\f")
            if (y[7] > 0) {
                dataSend += "\r" + y[0] + "\f0\f1\f" + y[7] + "\f" + (y[9] ? y[9] : '999') + "\f" + y[8]
                custCount++
            }
        })
        if (custCount) {

            Modal.confirm({
                content: `${this.getText(22355)}${custCount} ${this.getText(22356)}, ${this.getText(22357)} ${this.state.addToConnectedCustFilter._sumPointsToAdd}`,
                okText: this.getText(22358),
                cancelText: this.getText(22359),
                onOk: () => {
                    this.sendAPI("change_customer_points_bo", dataSend, () => {
                        this.setState({ modalMultiAddToConnectedCust: false, modalMultiAddToConnectedCustList: false }, () => {
                            message.success(this.getText(22360))
                        })
                    })
                },
                onCancel() { },
            })

        } else {
            message.error(this.getText(22361))
        }
    }

    sendAPI = (script, data, sCal) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCal, (e) => { console.error(e) });
    }

    render() {
        const { BranchesPoints } = this.state;

        let gt = this.getText;
        let render = text => text;

        const renderSumToAdd = (text, record) => {
            return (<InputNumber min={0} max={999999} style={{ width: "100%" }}
                autoFocus={record.index == 0}
                id={"input_sum_to_add_index_" + record.index}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                        let ne = document.getElementById("input_sum_to_add_index_" + (record.index + 1))
                        if (ne) ne.focus()
                    }
                }}
                value={text}
                onChange={e => {
                    const { _maxPointsToAdd } = this.state.addToConnectedCustFilter
                    let sumToAdd = 0;
                    let data = this.props.data[this.connected_id].data.map((x, i) => {
                        let y = x.split("\f")
                        if (i == record.index) {
                            y[7] = e === null ? "" : e
                            sumToAdd += e ? e : 0
                            return y.join("\f")
                        } else {
                            sumToAdd += parseFloat(y[7] ? y[7] : 0)
                            return x
                        }
                    })
                    if (_maxPointsToAdd > 0 && sumToAdd > _maxPointsToAdd) {
                        message.error(gt(22353))
                    } else {
                        this.setState({ addToConnectedCustFilter: { ...this.state.addToConnectedCustFilter, _sumPointsToAdd: sumToAdd } }, () => {
                            this.props.dataActions.setJson(this.connected_id, { data })
                        })
                    }

                }} />)
        }
        const renderRef = (text, record) => {
            return (<InputNumber min={0} value={text} style={{ width: "100%" }} onChange={e => {
                let data = this.props.data[this.connected_id].data.map((x, i) => {
                    if (i == record.index) {
                        let y = x.split("\f")
                        y[8] = e === null ? "" : e
                        return y.join("\f")
                    } else {
                        return x
                    }
                })
                this.props.dataActions.setJson(this.connected_id, { data })
            }} />)
        }
        const renderPosNumber = (text, record) => {
            return (<GenericSelector
                {...this.props}
                id={this.selectors[0].id}
                value={text}
                onChange={e => {
                    let data = this.props.data[this.connected_id].data.map((x, i) => {
                        if (i == record.index) {
                            let y = x.split("\f")
                            y[9] = e === null ? "" : e
                            return y.join("\f")
                        } else {
                            return x
                        }
                    })
                    this.props.dataActions.setJson(this.connected_id, { data })
                }} />)
        }

        let renderEditCol = (text, record) => {
            return (
                <span>
                    <Tooltip title={gt(10944)}>
                        <Icon style={{ fontSize: 16 }} className={"clickable margin-4"} type={"table"} onClick={() => {
                            this.setState({ customerId: record['dCustomerId'] },
                                this.props.uiActions.showModal(TableIDs.modalAccumulationOfPoints,
                                    { customerId: record['dCustomerId'], customerIndex: record.index }))
                        }} />
                    </Tooltip>
                    <Tooltip title={gt(10945)}>
                        <Icon style={{ fontSize: 16 }} className={"clickable margin-4"} type={"plus"} onClick={() => {
                            this.setState({ customerId: record['dCustomerId'] },
                                this.props.uiActions.showModal(TableIDs.modalCreateEditPointsCustomer,
                                    { customerId: record['dCustomerId'], customerIndex: record.index }));
                            this.props.dataActions.genericDataSetEdit("customer.editedRecord.customers",
                                { customerId: record['dCustomerId'], customerName: record['dCustomerName'] });
                            this.props.dataActions.genericDataSetFilter(
                                'MODAL_CREATE_EDIT_POINTS',
                                this.props.user.companyCode,
                                this.props.user.token,
                                { _id: record['dCustomerId'] },
                                'get_customer_points_data');
                        }} />
                    </Tooltip>
                </span>
            );
        }

        const divStyle = {
            align: "center",
            dir: "rtl", // dir: 'ltr'
            padding: "2% 2% 2% 2%",
        };

        let request = {
            // ui-pagination 
            _id: 0,
            _fieldId: false,
            page: 1,
            sortType: 1,
            // api
            _page_num: 1,
            _isAsc: 1,
            _sort_by: 'col_1',
        };

        let columns = [
            // { title: gt(10938), dataIndex: "dId", key: "dId", width: '10%', render },
            { title: gt(10939), dataIndex: "dCustomerId", key: "dCustomerId", width: '12%', render },
            { title: gt(10940), dataIndex: "dCustomerName", key: "dCustomerName", width: '14%', render },
            { title: gt(22333), dataIndex: "dCustomerFirstName", key: "dCustomerFirstName", width: '10%', render },
            { title: gt(22334), dataIndex: "dCustomerLastName", key: "dCustomerLastName", width: '10%', render },
            { title: gt(22335), dataIndex: "dCustomerMagneticCard", key: "dCustomerMagneticCard", width: '10%', render },
            { title: gt(12983), dataIndex: "dCustomerPhone", key: "dCustomerPhone", width: '12%', render },
            { title: gt(10941), dataIndex: "dName", key: "dName", width: '12%', render },
            { title: gt(10942), dataIndex: "dSumPoint", key: "dSumPoint", width: '12%', render },
            { title: gt(10943), width: '8%', render: renderEditCol }
        ];


        return (
            <div style={divStyle}>
                <ResponsiveTable
                    idTable={this.props.data[this.id]}
                    columns={columns}
                    percentageToMobile={[false, 30, 35, false, 35]}
                    title={gt(10937)}
                    actionButtons={this.actionButtons}
                    genericActionButtons={[
                        this.reportButton(),
                        <ReportFavoriteSave
                            {...this.props}
                            btnText={(<Icon type="save" />)}
                            btnTooltip={gt(16682)}
                            notSaveUrl
                            favoriteDesc={gt(16683)}
                            params={{
                                _id: 0,
                                _words: '',
                                _page_num: 1,
                                _rows_num: 999999,
                                _isAsc: 1,

                                _custId: this.state.modalFilterCustId ?? null,
                                _primaryCustId: this.state.modalFilterPrimaryCust ?? null,
                                _custTagList: this.state.modalFilterCustTags ?? "",

                                reportName: "reports/CustomerPoints.pdf",
                                REPORT_LOCALE: this.getText(101),
                            }}
                        />,
                        <Tooltip title={gt(16332)}>
                            <Button key={"report-print"} className={"btn"} style={{ marginTop: "5px", marginLeft: "5px" }} onClick={() => {
                                this.setState({ modalReportBranches: true })
                            }}><Icon style={{ fontSize: 16 }} type={"database"} theme="outlined" /></Button>
                        </Tooltip>,
                        <Tooltip title={gt(22339)}>
                            <Button key={"MultiAddToConnectedCust"} className={"btn"} style={{ marginTop: "5px", marginLeft: "5px" }} onClick={() => {
                                this.setState({ modalMultiAddToConnectedCust: true })
                            }}><Icon style={{ fontSize: 16 }} type={"team"} theme="outlined" /></Button>
                        </Tooltip>
                    ]}
                    showsearch={
                        (val) => {
                            this.props.dataActions.genericDataSetFilter(
                                this.id, this.props.user.companyCode, this.props.user.token,
                                {
                                    ...request, _words: val
                                        .trim().replace(/\s\s+/g, ' ').replace(/\'/g, "\\\'"),
                                    page: 1,
                                    _page_num: 1,
                                }, this.api.get)
                        }}
                    onChange={this.handleTableChange}
                    ui={this.props.ui}
                    uiActions={this.props.uiActions} />

                <ModalAccumulationOfPoints
                    id={TableIDs.modalAccumulationOfPoints}
                    user={this.props.user} ActionQueue={this.props.ActionQueue}
                    uiActions={this.props.uiActions} ui={this.props.ui}
                    dataActions={this.props.dataActions} data={this.props.data}
                    toggle={this.props.ui.modalStack.includes(TableIDs.modalAccumulationOfPoints)}
                />

                <ModalCreateEditPointsCustomer
                    id={TableIDs.modalCreateEditPointsCustomer}
                    user={this.props.user}
                    uiActions={this.props.uiActions} ui={this.props.ui}
                    dataActions={this.props.dataActions} data={this.props.data}
                    toggle={this.props.ui.modalStack.includes(TableIDs.modalCreateEditPointsCustomer)}
                />
                <GenericModal
                    visible={this.state.modalReportBranches}
                    onCancel={() => { this.setState({ modalReportBranches: false }) }}
                    width={600}
                    title={gt(16331)}>
                    <Row>
                        <Col span={12}>{this.getModalField(16333, 'date', 'dateFrom')}</Col>
                        <Col span={12}>{this.getModalField(16334, 'date', 'dateTo')}</Col>
                    </Row>
                    {this.getModalField(16335, 'checkbox', 'isPerBranch')}
                    {BranchesPoints.isPerBranch == '1' ? (
                        <FormItemInput
                            {...this.props}
                            label={gt(16336)}
                            inputType={'select'}
                            id={TableIDs.genericSelectorBranches}
                            api={'get_branch_list'}
                            multi
                            value={BranchesPoints.branchList ? BranchesPoints.branchList.split(',') : []}
                            onChange={e => {
                                this.setState({
                                    BranchesPoints: {
                                        ...this.state.BranchesPoints,
                                        branchList: e ? e.join(',') : ''
                                    }
                                })
                            }}
                        />
                    ) : ""}
                    <ReportTypeButton
                        {...this.props}
                        params={BranchesPoints}
                        branchesField={'branchList'}
                        xlsReportName={'reports/BranchesPointsExcel.xls'}
                        datesToFavorites={[
                            { field: 'dateFrom', label: gt(16333) },
                            { field: 'dateTo', label: gt(16334) },
                        ]}
                        favoriteSave
                        favoriteDesc={gt(16331)}
                    />

                </GenericModal>
                <GenericModal
                    visible={this.state.modalMultiAddToConnectedCust}
                    onCancel={() => { this.setState({ modalMultiAddToConnectedCust: false }) }}
                    title={gt(22340)}
                    width={500}
                    footer={[
                        <Button onClick={() => { this.setState({ modalMultiAddToConnectedCust: false }) }}>{gt(22342)}</Button>,
                        <Button type="primary" onClick={() => { this.setState({ modalMultiAddToConnectedCustList: true, addToConnectedCustFilter: { ...this.state.addToConnectedCustFilter, _sumPointsToAdd: 0 } }) }}>{gt(22341)}</Button>,
                    ]}>
                    <Form.Item label={gt(22343)} labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}>
                        <GenericSelectorCustomers
                            {...this.props}
                            onChange={() => { }}
                            onChangeGetDetailed={({ code, name }) => { this.setState({ addToConnectedCustFilter: { ...this.state.addToConnectedCustFilter, _custId: code, _custName: name } }) }}
                            value={this.state.addToConnectedCustFilter._custId}
                            isGroupFromConnected={"1"}
                        />
                    </Form.Item>
                    <Form.Item label={gt(22344)} labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}>
                        <InputNumber
                            style={{ width: "100%" }}
                            min={0} max={999999}
                            onChange={(value) => { this.setState({ addToConnectedCustFilter: { ...this.state.addToConnectedCustFilter, _maxPointsToAdd: value } }) }}
                            value={this.state.addToConnectedCustFilter._maxPointsToAdd}
                        />
                    </Form.Item>
                    <Form.Item label={gt(22345)} labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}>
                        <InputNumber
                            min={0}
                            style={{ width: "100%" }}
                            onChange={(value) => { this.setState({ addToConnectedCustFilter: { ...this.state.addToConnectedCustFilter, _ref: value } }) }}
                            value={this.state.addToConnectedCustFilter._ref}
                        />
                    </Form.Item>
                    <Form.Item label={gt(22346)} labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}>
                        <GenericSelector
                            {...this.props}
                            {...this.selectors[0]}
                            value={this.state.addToConnectedCustFilter._posNumber}
                            onChange={(value) => { this.setState({ addToConnectedCustFilter: { ...this.state.addToConnectedCustFilter, _posNumber: value } }) }}
                        />
                    </Form.Item>
                    <GenericModal
                        visible={this.state.modalMultiAddToConnectedCustList}
                        onCancel={() => { this.setState({ modalMultiAddToConnectedCustList: false }) }}
                        height={"auto"}
                        title={(<>
                            {gt(22347)}: {this.state.addToConnectedCustFilter._custId} - {this.state.addToConnectedCustFilter._custName}
                            <Row style={{ marginTop: 15 }}>
                                <Col span={8} style={{ border: '1px solid white', padding: 3, minHeight: 40 }}><b>{gt(22344)}</b></Col>
                                <Col span={8} style={{ border: '1px solid white', padding: 3, minHeight: 40 }}><b>{gt(22348)}</b></Col>
                                <Col span={8} style={{ border: '1px solid white', padding: 3, minHeight: 40 }}><b>{gt(22349)}</b></Col>
                                <Col span={8} style={{ border: '1px solid white', padding: 3, minHeight: 40 }}>{this.state.addToConnectedCustFilter._maxPointsToAdd}</Col>
                                <Col span={8} style={{ border: '1px solid white', padding: 3, minHeight: 40 }}>{this.state.addToConnectedCustFilter._sumPointsToAdd}</Col>
                                <Col span={8} style={{ border: '1px solid white', padding: 3, minHeight: 40 }}>
                                    {this.state.addToConnectedCustFilter._maxPointsToAdd ?
                                        this.state.addToConnectedCustFilter._maxPointsToAdd - this.state.addToConnectedCustFilter._sumPointsToAdd
                                        : null}
                                </Col>
                            </Row>
                        </>)}
                        footer={[
                            <Button onClick={() => { this.setState({ modalMultiAddToConnectedCustList: false }) }}>{gt(22342)}</Button>,
                            <Button type="primary" onClick={this.onSaveAddToConnectedCust}>{gt(22354)}</Button>,
                        ]}>
                        {this.state.modalMultiAddToConnectedCustList ?
                            <GenericTable {...this.props} tableOnly
                                id={this.connected_id}
                                getApi={this.api.get_connected}
                                filters={this.state.addToConnectedCustFilter}
                                columns={[
                                    { title: gt(10939), dataIndex: "dCustomerId", key: "dCustomerId", width: '12%', render },
                                    { title: gt(10940), dataIndex: "dCustomerName", key: "dCustomerName", width: '14%', render },
                                    { title: gt(22333), dataIndex: "dCustomerFirstName", key: "dCustomerFirstName", width: '10%', render },
                                    { title: gt(22334), dataIndex: "dCustomerLastName", key: "dCustomerLastName", width: '10%', render },
                                    { title: gt(22335), dataIndex: "dCustomerMagneticCard", key: "dCustomerMagneticCard", width: '10%', render },
                                    { title: gt(10942), dataIndex: "dSumPoint", key: "dSumPoint", width: '10%', render },
                                    { title: gt(22350), dataIndex: "dSumToAdd", key: "dSumToAdd", width: '10%', render: renderSumToAdd },
                                    { title: gt(22351), dataIndex: "dRef", key: "dRef", width: '12%', render: renderRef },
                                    { title: gt(22352), dataIndex: "dPosNumber", key: "dPosNumber", width: '12%', render: renderPosNumber },
                                ]}
                                scroll={{ y: window.innerHeight - 400 }}
                            />
                            : ""}

                        <Row style={{ marginTop: 15, width: 500, marginRight: "auto" }}>
                            <Col span={12} style={{ border: '1px solid black', padding: 3, minHeight: 40 }}><b>{gt(22344)}</b></Col>
                            <Col span={12} style={{ border: '1px solid black', padding: 3, minHeight: 40 }}>{this.state.addToConnectedCustFilter._maxPointsToAdd}</Col>
                            <Col span={12} style={{ border: '1px solid black', padding: 3, minHeight: 40 }}><b>{gt(22348)}</b></Col>
                            <Col span={12} style={{ border: '1px solid black', padding: 3, minHeight: 40 }}>{this.state.addToConnectedCustFilter._sumPointsToAdd}</Col>
                            <Col span={12} style={{ border: '1px solid black', padding: 3, minHeight: 40 }}><b>{gt(22349)}</b></Col>
                            <Col span={12} style={{ border: '1px solid black', padding: 3, minHeight: 40 }}>
                                {this.state.addToConnectedCustFilter._maxPointsToAdd ?
                                    this.state.addToConnectedCustFilter._maxPointsToAdd - this.state.addToConnectedCustFilter._sumPointsToAdd
                                    : null}
                            </Col>
                        </Row>
                    </GenericModal>
                </GenericModal>
                <GenericModal
                    visible={this.state.modalFilter}
                    onCancel={() => { this.setState({ modalFilter: false }) }}
                    title={gt(22340)}
                    width={500}
                    footer={[
                        <Button onClick={() => { this.setState({ modalFilter: false }) }}>{gt(22368)}</Button>,
                        <Button onClick={() => { this.setState({ modalFilterCustId: null, modalFilterPrimaryCust: null, modalFilterCustTags: "" }) }}>{gt(22369)}</Button>,
                        <Button type="primary" onClick={() => {
                            this.setState({ modalFilter: false }, () => {
                                this.props.dataActions.genericDataSetFilter(this.id, this.props.user.companyCode, this.props.user.token, {
                                    _custId: this.state.modalFilterCustId ?? null,
                                    _primaryCustId: this.state.modalFilterPrimaryCust ?? null,
                                    _custTagList: this.state.modalFilterCustTags ?? "",
                                    page: 1,
                                    _page_num: 1,
                                }, this.api.get)
                            })
                        }}>{gt(22370)}</Button>,
                    ]}>
                    <Form.Item label={gt(22371)}>
                        <CustPicker
                            {...this.props}
                            value={this.state.modalFilterCustId}
                            onChange={(value) => { this.setState({ modalFilterCustId: value }) }}
                            defaultView={this.getText(12121)}
                        />
                    </Form.Item>
                    <Form.Item label={gt(22372)}>
                        <GenericSelectorCustomers
                            {...this.props}
                            value={this.state.modalFilterPrimaryCust}
                            onChange={code => { this.setState({ modalFilterPrimaryCust: code }) }}
                            isGroupFromConnected={"1"}
                        />
                    </Form.Item>
                    <Form.Item label={gt(22373)}>
                        <GenericSelectorCustTags
                            {...this.props} multi
                            value={this.state.modalFilterCustTags ? this.state.modalFilterCustTags.split(",") : []}
                            onChange={e => { this.setState({ modalFilterCustTags: e ? e.join(",") : "" }) }}
                        />
                    </Form.Item>
                </GenericModal>
            </div>
        );
    }
}

export default CustomerPoints;

